import {
  Band,
  ragStatusWithDesc,
  VisitTypeWithName,
  VisitStatusWithName,
  TreatmentScheduleWithName,
} from '../../../../enums';
import globals from '../../../../globals/communityGlobals';

const locale = globals.getArea('advanceFilters');

export const AdvanceFilters = [
  {
    name: 'visitType',
    label: locale.getMsg('visitType'),
    type: 'select',
    isMultiple: true,
    options: VisitTypeWithName.map(r => ({ id: r.id, name: r.name })),
    optionsLength: VisitTypeWithName.length,
  },
  {
    name: 'visitStatus',
    label: locale.getMsg('visitStatus'),
    type: 'select',
    isMultiple: true,
    options: VisitStatusWithName.map(r => ({ id: r.id, name: r.name })),
    optionsLength: VisitStatusWithName.length,
  },
  { name: 'nhs', label: locale.getMsg('nhs'), type: 'textField', error: '' },
  {
    name: 'activity',
    label: locale.getMsg('activity'),
    type: 'select',
    isMultiple: true,
    options: [],
    optionsLength: 0,
    isLoading: false,
  },
  {
    name: 'multipleClinicians',
    label: locale.getMsg('multipleClinicians'),
    type: 'select',
    isMultiple: false,
    options: [{ id: 0, name: 'Yes' }, { id: 1, name: 'No' }],
  },
  { name: 'postcode', label: locale.getMsg('postcode'), type: 'textField', error: '' },
  {
    name: 'rag',
    label: locale.getMsg('rag'),
    type: 'select',
    isMultiple: true,
    options: ragStatusWithDesc
      .sort((a, b) => b.sortingOrder - a.sortingOrder)
      .map(r => ({ id: r.id, name: r.description })),
    optionsLength: ragStatusWithDesc.length,
  },
  {
    name: 'band',
    label: locale.getMsg('band'),
    type: 'select',
    isMultiple: true,
    options: Band.sort((a, b) => a.sortingOrder - b.sortingOrder).map(b => ({ id: b.id, name: b.Name })),
    optionsLength: Band.length,
  },
  {
    name: 'treatmentSchedule',
    label: locale.getMsg('treatmentSchedule'),
    type: 'select',
    isMultiple: true,
    options: TreatmentScheduleWithName.map(r => ({ id: r.id, name: r.name })),
    optionsLength: TreatmentScheduleWithName.length,
  },
];
